/**
 * `?highlight=<id>` — the row a link arrived for.
 *
 * The Activity panel links a cap back to the limit that caused it, and
 * "open Setup" is only half an answer if the operator then has to find
 * the row among a hundred and across four pages (Curro, 2026-09-28).
 *
 * The id is left in the URL so the link stays shareable; `seen` goes
 * true after the first paint so the flash plays once rather than on
 * every render.
 */
import { useEffect, useState } from 'react'
import { dsColorNew } from '@palette'
import { useSearchParams } from 'react-router-dom'

export function useHighlight() {
	const [searchParams] = useSearchParams()
	const id = searchParams.get('highlight') || null
	const [seen, setSeen] = useState(false)

	useEffect(() => {
		if (!id || seen) return undefined
		// One frame, so the row exists before it is scrolled to.
		const t = setTimeout(() => setSeen(true), 2200)
		return () => clearTimeout(t)
	}, [id, seen])

	return { id, active: !!id && !seen }
}

/** Scroll a row into view once, and flash it while `active`. */
export function highlightSx(active) {
	return active
		? {
			bgcolor: dsColorNew.noteAmberBg,
			boxShadow: `inset 3px 0 0 ${dsColorNew.warningBar}`,
			transition: 'background-color 600ms ease',
		}
		: undefined
}
